module.exports = __webpack_public_path__ + "img/BatAgriSerreR.9aa99a5d.png";